var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRightChevron = function SvgRightChevron(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5 67C52.0015 67 67 52.0015 67 33.5C67 14.9985 52.0015 -1.31121e-06 33.5 -2.92866e-06C14.9985 -4.54612e-06 4.54612e-06 14.9985 2.92866e-06 33.5C1.31121e-06 52.0015 14.9985 67 33.5 67ZM22.7096 46.3535C21.248 47.6184 21.0885 49.8288 22.3535 51.2904C23.6185 52.752 25.8288 52.9115 27.2904 51.6465L46.2904 35.203C47.0862 34.5143 47.5298 33.5041 47.4984 32.4522C47.4671 31.4002 46.964 30.4182 46.1286 29.7782L27.1286 15.2217C25.5941 14.0461 23.3972 14.337 22.2217 15.8714C21.0461 17.4059 21.337 19.6028 22.8714 20.7783L38.4607 32.7218L22.7096 46.3535Z",
    fill: "white",
    fillOpacity: 0.75
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRightChevron, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/RightChevron.cbcccc2c.svg";
export { ForwardRef as ReactComponent };